import React, {useContext, useEffect, useState} from "react";
import styles from './hub.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight, faPlus, faSignOut} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";
import Modal from "../../components/modal/modal";
import {LogoInput, TextInput} from "../../components/input/inputs";
import axiosInstance from "../../AxiosInstance";
import MyContext from "../../Context";
import {useTranslation} from "react-i18next";

export default function Hub() {
    const {t} = useTranslation();
    const [companies, setCompanies] = useState([]);
    const [show, setShow] = useState(false);
    const [form, setForm] = useState({});
    const [loaded, setLoaded] = useState(false);
    const {setCompanyChange, corporateGroup, user} = useContext(MyContext);

    useEffect(() => {
        axiosInstance.get('company/').then((response) => {
            if(response.status === 206) {
                const tempComp = response.data;
                localStorage.setItem('company', JSON.stringify(tempComp));
                localStorage.setItem('company_id', tempComp.id);

                const defaultOffice = tempComp.default_project || (tempComp.projects?.length > 0 ? tempComp.projects[0] : null);
                if (defaultOffice) {
                    localStorage.setItem('project', JSON.stringify(defaultOffice));
                    localStorage.setItem('project_id', defaultOffice.id);
                } else {
                    localStorage.removeItem('project');
                    localStorage.removeItem('project_id');
                }

                localStorage.setItem('offices', JSON.stringify(tempComp.projects || []));
                window.location.replace('/resources');
            } else {
                setCompanies(response.data);
                setLoaded(true);
            }
        });
    }, [])

    const switchProjects = (company) => {
        localStorage.setItem('company', JSON.stringify(company));
        localStorage.setItem('company_id', company.id);

        // Filter to only the user's allowed projects within this company (if restricted)
        const allowedProjectIds = user?.allowed_projects?.length > 0
            ? new Set(user.allowed_projects.map(p => String(p.id)))
            : null;
        const availableProjects = allowedProjectIds
            ? (company.projects || []).filter(p => allowedProjectIds.has(String(p.id)))
            : (company.projects || []);

        const defaultOffice = company.default_project && (!allowedProjectIds || allowedProjectIds.has(String(company.default_project.id)))
            ? company.default_project
            : (availableProjects.length > 0 ? availableProjects[0] : null);

        if (defaultOffice) {
            localStorage.setItem('project', JSON.stringify(defaultOffice));
            localStorage.setItem('project_id', defaultOffice.id);
        } else {
            localStorage.removeItem('project');
            localStorage.removeItem('project_id');
        }

        localStorage.setItem('offices', JSON.stringify(availableProjects));
    }

    const createCompany = () => {
        let formData = new FormData();
        for(const key in form) {
            formData.append(key, form[key]);
        }

        axiosInstance.post('company/', formData).then((response) => {
            window.location.reload();
        }).catch(() => {});
    }

    const logout = () => {
        localStorage.clear();
        axiosInstance.defaults.headers.common['Authorization'] = null;
        window.location.replace('/login');
    }

    return (
        <div className={'w-100 h-100'} style={{backgroundColor: "#F1F5F9"}}>
            <Modal show={show} setter={setShow} name={t('hub.createCompany')} buttonName={t('hub.create')} onClick={createCompany}>
                <LogoInput name={t('hub.companyLogo')} internalName={'logo'} form={form} setForm={setForm} hideName={true}/>
                <TextInput name={t('hub.companyName')} internalName={'name'} form={form} setForm={setForm} hideName={true} placeholder={t('hub.companyName')}/>
                <TextInput name={t('hub.officeName')} internalName={'office'} form={form} setForm={setForm} hideName={true} placeholder={t('hub.officeName')}/>
            </Modal>

            {!loaded &&
            <div style={{
                position: "absolute",
                width: '100vw',
                height: '100vh',
                top: 0,
                left: 0,
                backgroundColor: '#FFF',
                zIndex: '9999999',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <div style={{
                    marginTop: '-40px'
                }}>
                    <img height={'40px'} src={'/mid_purple.png'} alt={'MyIndustrialData Logo'}/>
                </div>
            </div>
            }

            <div className={styles.container}>
                <div className={'my-5'}>
                    <img height={'40px'} src={'/mid_purple.png'} alt={'MyIndustrialData Logo'}/>
                </div>
                <div>
                    <div className={`${styles.corpContainer} mb-3`}>
                        <img
                            src={corporateGroup?.image ? corporateGroup?.image?.image : '/mid_cloud.png'}
                            alt={'corporate_logo'}
                            style={{
                                maxHeight: '44px',
                                maxWidth: '140px',
                                objectFit: 'contain',
                                borderRadius: '6px',
                                padding: '4px',
                                backgroundColor: 'rgba(255, 255, 255, 0.1)'
                            }}
                        />
                        <div className={'ps-3'} style={{fontSize: '18px', fontWeight: '600'}}>{corporateGroup?.name}</div>
                    </div>

                    <div className={styles.companies}>
                        {(user?.is_superuser || user?.role?.permissions?.find(p => p.module === 'companies')?.can_create) && (
                            <div className={`${styles.companyContainer} ${styles.create}`} onClick={() => setShow(true)}>
                                <div className={'d-flex justify-content-between'}>
                                    <div style={{backgroundColor: "#F1F5F9", padding: "6px 10px", borderRadius: "6px"}}>
                                        <img height={'18px'} src={'/hut.png'} alt={'hut'}/>
                                    </div>
                                    <FontAwesomeIcon icon={faPlus} color={"#625CE8"}/>
                                </div>
                                <div style={{fontWeight: '600'}}>{t('hub.createCompany')}</div>
                            </div>
                        )}
                        {companies?.map((company) => (
                            <Link key={company.id} to={'/resources'} className={`${styles.companyContainer}`} onClick={() => switchProjects(company)}>
                                <div className={'d-flex justify-content-between align-items-start'}>
                                    <div style={{
                                        backgroundColor: "#F8FAFC",
                                        padding: "8px",
                                        borderRadius: "8px",
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        minWidth: '52px',
                                        minHeight: '52px'
                                    }}>
                                        <img
                                            src={company?.image?.image || '/mid_cloud.png'}
                                            alt={company?.name}
                                            style={{
                                                maxHeight: '36px',
                                                maxWidth: '80px',
                                                objectFit: 'contain'
                                            }}
                                        />
                                    </div>
                                    <FontAwesomeIcon icon={faArrowRight} color={'#94A3B8'}/>
                                </div>
                                <div className={'d-flex align-items-center'}>
                                    {company.show_danger && <div style={{backgroundColor: 'red', width: '8px', height: '8px', borderRadius: '50%'}} className={'me-2'}/>}
                                    <div style={{fontWeight: '600', color: "#334155"}}>{company.name}</div>
                                </div>
                            </Link>
                        ))}
                    </div>

                    <div className={'d-flex flex-row w-100 justify-content-center'}>
                        <div className={`d-flex ${styles.logout} mb-3`} onClick={() => logout()}>
                            <FontAwesomeIcon icon={faSignOut} className={'pt-1 pe-2'}/>
                            <div>{t('header.logout')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}